package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets12 {
  internal val _30_shir_hashirim_03_txt: AssetResource by lazy { init__30_shir_hashirim_03_txt() }

  internal val _30_shir_hashirim_04_txt: AssetResource by lazy { init__30_shir_hashirim_04_txt() }

  internal val _30_shir_hashirim_05_txt: AssetResource by lazy { init__30_shir_hashirim_05_txt() }

  internal val _30_shir_hashirim_06_txt: AssetResource by lazy { init__30_shir_hashirim_06_txt() }

  internal val _30_shir_hashirim_07_txt: AssetResource by lazy { init__30_shir_hashirim_07_txt() }

  internal val _30_shir_hashirim_08_txt: AssetResource by lazy { init__30_shir_hashirim_08_txt() }

  internal val _31_ruth_01_txt: AssetResource by lazy { init__31_ruth_01_txt() }

  internal val _31_ruth_02_txt: AssetResource by lazy { init__31_ruth_02_txt() }

  internal val _31_ruth_03_txt: AssetResource by lazy { init__31_ruth_03_txt() }

  internal val _31_ruth_04_txt: AssetResource by lazy { init__31_ruth_04_txt() }

  internal val _32_eicha_01_txt: AssetResource by lazy { init__32_eicha_01_txt() }

  internal val _32_eicha_02_txt: AssetResource by lazy { init__32_eicha_02_txt() }

  internal val _32_eicha_03_txt: AssetResource by lazy { init__32_eicha_03_txt() }

  internal val _32_eicha_04_txt: AssetResource by lazy { init__32_eicha_04_txt() }

  internal val _32_eicha_05_txt: AssetResource by lazy { init__32_eicha_05_txt() }

  internal val _33_koheleth_01_txt: AssetResource by lazy { init__33_koheleth_01_txt() }

  internal val _33_koheleth_02_txt: AssetResource by lazy { init__33_koheleth_02_txt() }

  internal val _33_koheleth_03_txt: AssetResource by lazy { init__33_koheleth_03_txt() }

  internal val _33_koheleth_04_txt: AssetResource by lazy { init__33_koheleth_04_txt() }

  internal val _33_koheleth_05_txt: AssetResource by lazy { init__33_koheleth_05_txt() }

  internal val _33_koheleth_06_txt: AssetResource by lazy { init__33_koheleth_06_txt() }

  internal val _33_koheleth_07_txt: AssetResource by lazy { init__33_koheleth_07_txt() }

  internal val _33_koheleth_08_txt: AssetResource by lazy { init__33_koheleth_08_txt() }

  internal val _33_koheleth_09_txt: AssetResource by lazy { init__33_koheleth_09_txt() }

  internal val _33_koheleth_10_txt: AssetResource by lazy { init__33_koheleth_10_txt() }

  internal val _33_koheleth_11_txt: AssetResource by lazy { init__33_koheleth_11_txt() }

  internal val _33_koheleth_12_txt: AssetResource by lazy { init__33_koheleth_12_txt() }

  internal val _34_ester_01_txt: AssetResource by lazy { init__34_ester_01_txt() }

  internal val _34_ester_02_txt: AssetResource by lazy { init__34_ester_02_txt() }

  internal val _34_ester_03_txt: AssetResource by lazy { init__34_ester_03_txt() }

  internal val _34_ester_04_txt: AssetResource by lazy { init__34_ester_04_txt() }

  internal val _34_ester_05_txt: AssetResource by lazy { init__34_ester_05_txt() }

  internal val _34_ester_06_txt: AssetResource by lazy { init__34_ester_06_txt() }

  internal val _34_ester_07_txt: AssetResource by lazy { init__34_ester_07_txt() }

  internal val _34_ester_08_txt: AssetResource by lazy { init__34_ester_08_txt() }

  internal val _34_ester_09_txt: AssetResource by lazy { init__34_ester_09_txt() }

  internal val _34_ester_10_txt: AssetResource by lazy { init__34_ester_10_txt() }

  internal val _35_daniel_01_txt: AssetResource by lazy { init__35_daniel_01_txt() }

  internal val _35_daniel_02_txt: AssetResource by lazy { init__35_daniel_02_txt() }

  internal val _35_daniel_03_txt: AssetResource by lazy { init__35_daniel_03_txt() }

  internal val _35_daniel_04_txt: AssetResource by lazy { init__35_daniel_04_txt() }

  internal val _35_daniel_05_txt: AssetResource by lazy { init__35_daniel_05_txt() }

  internal val _35_daniel_06_txt: AssetResource by lazy { init__35_daniel_06_txt() }

  internal val _35_daniel_07_txt: AssetResource by lazy { init__35_daniel_07_txt() }

  internal val _35_daniel_08_txt: AssetResource by lazy { init__35_daniel_08_txt() }

  internal val _35_daniel_09_txt: AssetResource by lazy { init__35_daniel_09_txt() }

  internal val _35_daniel_10_txt: AssetResource by lazy { init__35_daniel_10_txt() }

  internal val _35_daniel_11_txt: AssetResource by lazy { init__35_daniel_11_txt() }

  internal val _35_daniel_12_txt: AssetResource by lazy { init__35_daniel_12_txt() }

  internal val _36_ezra_01_txt: AssetResource by lazy { init__36_ezra_01_txt() }

  internal fun values(): List<AssetResource> = listOf(_30_shir_hashirim_03_txt,
      _30_shir_hashirim_04_txt, _30_shir_hashirim_05_txt, _30_shir_hashirim_06_txt,
      _30_shir_hashirim_07_txt, _30_shir_hashirim_08_txt, _31_ruth_01_txt, _31_ruth_02_txt,
      _31_ruth_03_txt, _31_ruth_04_txt, _32_eicha_01_txt, _32_eicha_02_txt, _32_eicha_03_txt,
      _32_eicha_04_txt, _32_eicha_05_txt, _33_koheleth_01_txt, _33_koheleth_02_txt,
      _33_koheleth_03_txt, _33_koheleth_04_txt, _33_koheleth_05_txt, _33_koheleth_06_txt,
      _33_koheleth_07_txt, _33_koheleth_08_txt, _33_koheleth_09_txt, _33_koheleth_10_txt,
      _33_koheleth_11_txt, _33_koheleth_12_txt, _34_ester_01_txt, _34_ester_02_txt,
      _34_ester_03_txt, _34_ester_04_txt, _34_ester_05_txt, _34_ester_06_txt, _34_ester_07_txt,
      _34_ester_08_txt, _34_ester_09_txt, _34_ester_10_txt, _35_daniel_01_txt, _35_daniel_02_txt,
      _35_daniel_03_txt, _35_daniel_04_txt, _35_daniel_05_txt, _35_daniel_06_txt, _35_daniel_07_txt,
      _35_daniel_08_txt, _35_daniel_09_txt, _35_daniel_10_txt, _35_daniel_11_txt, _35_daniel_12_txt,
      _36_ezra_01_txt)
}

private fun init__30_shir_hashirim_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_30_shir_hashirim-03.txt\")") as String, rawPath =
    "allChapters/_30_shir_hashirim-03.txt")

private fun init__30_shir_hashirim_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_30_shir_hashirim-04.txt\")") as String, rawPath =
    "allChapters/_30_shir_hashirim-04.txt")

private fun init__30_shir_hashirim_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_30_shir_hashirim-05.txt\")") as String, rawPath =
    "allChapters/_30_shir_hashirim-05.txt")

private fun init__30_shir_hashirim_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_30_shir_hashirim-06.txt\")") as String, rawPath =
    "allChapters/_30_shir_hashirim-06.txt")

private fun init__30_shir_hashirim_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_30_shir_hashirim-07.txt\")") as String, rawPath =
    "allChapters/_30_shir_hashirim-07.txt")

private fun init__30_shir_hashirim_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_30_shir_hashirim-08.txt\")") as String, rawPath =
    "allChapters/_30_shir_hashirim-08.txt")

private fun init__31_ruth_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_31_ruth-01.txt\")") as String, rawPath =
    "allChapters/_31_ruth-01.txt")

private fun init__31_ruth_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_31_ruth-02.txt\")") as String, rawPath =
    "allChapters/_31_ruth-02.txt")

private fun init__31_ruth_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_31_ruth-03.txt\")") as String, rawPath =
    "allChapters/_31_ruth-03.txt")

private fun init__31_ruth_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_31_ruth-04.txt\")") as String, rawPath =
    "allChapters/_31_ruth-04.txt")

private fun init__32_eicha_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_32_eicha-01.txt\")") as String, rawPath =
    "allChapters/_32_eicha-01.txt")

private fun init__32_eicha_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_32_eicha-02.txt\")") as String, rawPath =
    "allChapters/_32_eicha-02.txt")

private fun init__32_eicha_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_32_eicha-03.txt\")") as String, rawPath =
    "allChapters/_32_eicha-03.txt")

private fun init__32_eicha_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_32_eicha-04.txt\")") as String, rawPath =
    "allChapters/_32_eicha-04.txt")

private fun init__32_eicha_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_32_eicha-05.txt\")") as String, rawPath =
    "allChapters/_32_eicha-05.txt")

private fun init__33_koheleth_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-01.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-01.txt")

private fun init__33_koheleth_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-02.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-02.txt")

private fun init__33_koheleth_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-03.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-03.txt")

private fun init__33_koheleth_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-04.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-04.txt")

private fun init__33_koheleth_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-05.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-05.txt")

private fun init__33_koheleth_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-06.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-06.txt")

private fun init__33_koheleth_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-07.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-07.txt")

private fun init__33_koheleth_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-08.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-08.txt")

private fun init__33_koheleth_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-09.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-09.txt")

private fun init__33_koheleth_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-10.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-10.txt")

private fun init__33_koheleth_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-11.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-11.txt")

private fun init__33_koheleth_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_33_koheleth-12.txt\")") as String, rawPath =
    "allChapters/_33_koheleth-12.txt")

private fun init__34_ester_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_34_ester-01.txt\")") as String, rawPath =
    "allChapters/_34_ester-01.txt")

private fun init__34_ester_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_34_ester-02.txt\")") as String, rawPath =
    "allChapters/_34_ester-02.txt")

private fun init__34_ester_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_34_ester-03.txt\")") as String, rawPath =
    "allChapters/_34_ester-03.txt")

private fun init__34_ester_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_34_ester-04.txt\")") as String, rawPath =
    "allChapters/_34_ester-04.txt")

private fun init__34_ester_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_34_ester-05.txt\")") as String, rawPath =
    "allChapters/_34_ester-05.txt")

private fun init__34_ester_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_34_ester-06.txt\")") as String, rawPath =
    "allChapters/_34_ester-06.txt")

private fun init__34_ester_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_34_ester-07.txt\")") as String, rawPath =
    "allChapters/_34_ester-07.txt")

private fun init__34_ester_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_34_ester-08.txt\")") as String, rawPath =
    "allChapters/_34_ester-08.txt")

private fun init__34_ester_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_34_ester-09.txt\")") as String, rawPath =
    "allChapters/_34_ester-09.txt")

private fun init__34_ester_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_34_ester-10.txt\")") as String, rawPath =
    "allChapters/_34_ester-10.txt")

private fun init__35_daniel_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-01.txt\")") as String, rawPath =
    "allChapters/_35_daniel-01.txt")

private fun init__35_daniel_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-02.txt\")") as String, rawPath =
    "allChapters/_35_daniel-02.txt")

private fun init__35_daniel_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-03.txt\")") as String, rawPath =
    "allChapters/_35_daniel-03.txt")

private fun init__35_daniel_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-04.txt\")") as String, rawPath =
    "allChapters/_35_daniel-04.txt")

private fun init__35_daniel_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-05.txt\")") as String, rawPath =
    "allChapters/_35_daniel-05.txt")

private fun init__35_daniel_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-06.txt\")") as String, rawPath =
    "allChapters/_35_daniel-06.txt")

private fun init__35_daniel_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-07.txt\")") as String, rawPath =
    "allChapters/_35_daniel-07.txt")

private fun init__35_daniel_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-08.txt\")") as String, rawPath =
    "allChapters/_35_daniel-08.txt")

private fun init__35_daniel_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-09.txt\")") as String, rawPath =
    "allChapters/_35_daniel-09.txt")

private fun init__35_daniel_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-10.txt\")") as String, rawPath =
    "allChapters/_35_daniel-10.txt")

private fun init__35_daniel_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-11.txt\")") as String, rawPath =
    "allChapters/_35_daniel-11.txt")

private fun init__35_daniel_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_35_daniel-12.txt\")") as String, rawPath =
    "allChapters/_35_daniel-12.txt")

private fun init__36_ezra_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_36_ezra-01.txt\")") as String, rawPath =
    "allChapters/_36_ezra-01.txt")

public actual val SharedRes.assets.allChapters._30_shir_hashirim_03_txt: AssetResource
  get() = CommonMainAssets12._30_shir_hashirim_03_txt

public actual val SharedRes.assets.allChapters._30_shir_hashirim_04_txt: AssetResource
  get() = CommonMainAssets12._30_shir_hashirim_04_txt

public actual val SharedRes.assets.allChapters._30_shir_hashirim_05_txt: AssetResource
  get() = CommonMainAssets12._30_shir_hashirim_05_txt

public actual val SharedRes.assets.allChapters._30_shir_hashirim_06_txt: AssetResource
  get() = CommonMainAssets12._30_shir_hashirim_06_txt

public actual val SharedRes.assets.allChapters._30_shir_hashirim_07_txt: AssetResource
  get() = CommonMainAssets12._30_shir_hashirim_07_txt

public actual val SharedRes.assets.allChapters._30_shir_hashirim_08_txt: AssetResource
  get() = CommonMainAssets12._30_shir_hashirim_08_txt

public actual val SharedRes.assets.allChapters._31_ruth_01_txt: AssetResource
  get() = CommonMainAssets12._31_ruth_01_txt

public actual val SharedRes.assets.allChapters._31_ruth_02_txt: AssetResource
  get() = CommonMainAssets12._31_ruth_02_txt

public actual val SharedRes.assets.allChapters._31_ruth_03_txt: AssetResource
  get() = CommonMainAssets12._31_ruth_03_txt

public actual val SharedRes.assets.allChapters._31_ruth_04_txt: AssetResource
  get() = CommonMainAssets12._31_ruth_04_txt

public actual val SharedRes.assets.allChapters._32_eicha_01_txt: AssetResource
  get() = CommonMainAssets12._32_eicha_01_txt

public actual val SharedRes.assets.allChapters._32_eicha_02_txt: AssetResource
  get() = CommonMainAssets12._32_eicha_02_txt

public actual val SharedRes.assets.allChapters._32_eicha_03_txt: AssetResource
  get() = CommonMainAssets12._32_eicha_03_txt

public actual val SharedRes.assets.allChapters._32_eicha_04_txt: AssetResource
  get() = CommonMainAssets12._32_eicha_04_txt

public actual val SharedRes.assets.allChapters._32_eicha_05_txt: AssetResource
  get() = CommonMainAssets12._32_eicha_05_txt

public actual val SharedRes.assets.allChapters._33_koheleth_01_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_01_txt

public actual val SharedRes.assets.allChapters._33_koheleth_02_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_02_txt

public actual val SharedRes.assets.allChapters._33_koheleth_03_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_03_txt

public actual val SharedRes.assets.allChapters._33_koheleth_04_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_04_txt

public actual val SharedRes.assets.allChapters._33_koheleth_05_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_05_txt

public actual val SharedRes.assets.allChapters._33_koheleth_06_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_06_txt

public actual val SharedRes.assets.allChapters._33_koheleth_07_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_07_txt

public actual val SharedRes.assets.allChapters._33_koheleth_08_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_08_txt

public actual val SharedRes.assets.allChapters._33_koheleth_09_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_09_txt

public actual val SharedRes.assets.allChapters._33_koheleth_10_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_10_txt

public actual val SharedRes.assets.allChapters._33_koheleth_11_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_11_txt

public actual val SharedRes.assets.allChapters._33_koheleth_12_txt: AssetResource
  get() = CommonMainAssets12._33_koheleth_12_txt

public actual val SharedRes.assets.allChapters._34_ester_01_txt: AssetResource
  get() = CommonMainAssets12._34_ester_01_txt

public actual val SharedRes.assets.allChapters._34_ester_02_txt: AssetResource
  get() = CommonMainAssets12._34_ester_02_txt

public actual val SharedRes.assets.allChapters._34_ester_03_txt: AssetResource
  get() = CommonMainAssets12._34_ester_03_txt

public actual val SharedRes.assets.allChapters._34_ester_04_txt: AssetResource
  get() = CommonMainAssets12._34_ester_04_txt

public actual val SharedRes.assets.allChapters._34_ester_05_txt: AssetResource
  get() = CommonMainAssets12._34_ester_05_txt

public actual val SharedRes.assets.allChapters._34_ester_06_txt: AssetResource
  get() = CommonMainAssets12._34_ester_06_txt

public actual val SharedRes.assets.allChapters._34_ester_07_txt: AssetResource
  get() = CommonMainAssets12._34_ester_07_txt

public actual val SharedRes.assets.allChapters._34_ester_08_txt: AssetResource
  get() = CommonMainAssets12._34_ester_08_txt

public actual val SharedRes.assets.allChapters._34_ester_09_txt: AssetResource
  get() = CommonMainAssets12._34_ester_09_txt

public actual val SharedRes.assets.allChapters._34_ester_10_txt: AssetResource
  get() = CommonMainAssets12._34_ester_10_txt

public actual val SharedRes.assets.allChapters._35_daniel_01_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_01_txt

public actual val SharedRes.assets.allChapters._35_daniel_02_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_02_txt

public actual val SharedRes.assets.allChapters._35_daniel_03_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_03_txt

public actual val SharedRes.assets.allChapters._35_daniel_04_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_04_txt

public actual val SharedRes.assets.allChapters._35_daniel_05_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_05_txt

public actual val SharedRes.assets.allChapters._35_daniel_06_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_06_txt

public actual val SharedRes.assets.allChapters._35_daniel_07_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_07_txt

public actual val SharedRes.assets.allChapters._35_daniel_08_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_08_txt

public actual val SharedRes.assets.allChapters._35_daniel_09_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_09_txt

public actual val SharedRes.assets.allChapters._35_daniel_10_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_10_txt

public actual val SharedRes.assets.allChapters._35_daniel_11_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_11_txt

public actual val SharedRes.assets.allChapters._35_daniel_12_txt: AssetResource
  get() = CommonMainAssets12._35_daniel_12_txt

public actual val SharedRes.assets.allChapters._36_ezra_01_txt: AssetResource
  get() = CommonMainAssets12._36_ezra_01_txt
